const helper = {
    /**
     * Laravel validation error 메시지 객체에서 특정 에러 메시지만 검색.
     * @param errors Object
     * @param key String
     * @returns {null|String}
     */
    retrieveFormError(errors, key) {
        if (errors && errors[key] && errors[key].length > 0) {
            return errors[key][0];
        }

        return null;
    },

    retrieveAllFormError(errors) {
        const formErrors = {};

        Object.keys(errors).forEach(value => {
            formErrors[value] = this.retrieveFormError(errors, value);
        });

        return formErrors;
    },

    /**
     * axios 에러 처리.
     * @param vue
     * @param error
     * @param passStatuses 에러 처리를 하지 않을 상태 코드 목록.
     * @return {null|Number}
     */
    axiosCatchError(vue, error, passStatuses = []) {
        if (error.response) {
            if (!passStatuses.includes(error.response.status)) {
                // csrf 토큰이 만료됐거나 없는 경우.
                if (error.response.status === 419) {
                    alert("보안 토큰이 만료되었습니다.");
                } else if (error.response.status === 401) {
                    alert("인증이 만료되었습니다.");
                } else if (error.response.status === 403) {
                    alert("권한이 없습니다.");
                } else {
                    alert(error.response.data?.message || "에러가 발생하였습니다.");
                }
            }

            return error.response.status;
        } else if (error.request) {
            alert("통신 중 장애가 발생하였습니다.");
        } else {
            alert("오류가 발생하였습니다.");
        }

        return null;
    },

    /**
     * 폼 전송시 사용할 헤더.
     * @returns {{Accept: string, "Content-Type": string}}
     */
    axiosPostHeaders() {
        return {
            "Content-Type": "application/json",
            Accept: "application/json",
        };
    },

    /**
     * http 전송시 사용할 헤더.
     * @returns {{Accept: string}}
     */
    axiosGetHeaders() {
        return {
            Accept: "application/json",
        };
    },

    /**
     * 쿠키값 설정.
     * @param name
     * @param value
     * @param days
     */
    setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    /**
     * 쿠키값 가져오기.
     * @param name
     * @returns {string|null}
     */
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

};

export default helper;
